import React from 'react';
import * as S from './styles';
import { ReactComponent as CalendarIcon } from "assets/icons/calendar.svg";

export const ScheduleMessageModalFooter = ({
  onFooterClick
}: {
  onFooterClick: () => void;
}) => {
  return (
    <S.FooterButton onClick={onFooterClick}>
      <CalendarIcon />
      Escolher data e hora
    </S.FooterButton>
  );
};
